import { useEffect, useState } from 'react';
import { localStorageConstants } from '../constants';
import { useSelector } from 'react-redux';
import { RootState } from '../store/reducer';
import { isInTimeIntervalToNow } from '../v2/util/datetime';

// if the organization was created in 5 minutes, we will consider to show welcome screen.
const WELCOME_SCREEN_INTERVAL_IN_MILLISECONDS = 300_000;

export const useWelcome = () => {
  const [isWelcomeVisible, setWelcomeVisible] = useState<boolean>();

  const { selectedOrganization } = useSelector(
    (state: RootState) => state.organizationList
  );

  useEffect(() => {
    if (isWelcomeVisible) {
      return;
    }

    if (!selectedOrganization) {
      return;
    }

    const isInTime = isInTimeIntervalToNow(
      selectedOrganization.createdAt,
      WELCOME_SCREEN_INTERVAL_IN_MILLISECONDS
    );

    if (!isInTime) {
      setWelcomeVisible(false);
      return;
    }

    try {
      let storedData = localStorage.getItem(
        localStorageConstants.WELCOME_ORGANIZATION
      );

      const showedOrganizationIds = JSON.parse(storedData ?? '');

      if (!showedOrganizationIds || !Array.isArray(showedOrganizationIds)) {
        setWelcomeVisible(true);
        updateShowedOrganization([selectedOrganization.id]);

        return;
      }

      const isExisted = showedOrganizationIds.find(
        (organizationId) => organizationId === selectedOrganization.id
      );
      if (!isExisted) {
        setWelcomeVisible(true);
        showedOrganizationIds.push(selectedOrganization.id);
        updateShowedOrganization(showedOrganizationIds);

        return;
      }

      setWelcomeVisible(false);
    } catch (e) {
      setWelcomeVisible(true);
      updateShowedOrganization([selectedOrganization.id]);
    }
  });

  const onClose = () => {
    setWelcomeVisible(false);
  };

  const updateShowedOrganization = (showedOrganizationIds: number[]) => {
    localStorage.setItem(
      localStorageConstants.WELCOME_ORGANIZATION,
      JSON.stringify(showedOrganizationIds)
    );
  };

  return { isWelcomeVisible, onClose };
};
